import React, { useState } from "react";
import PropTypes from "prop-types";
import { IonButton } from "@ionic/react";

function InGame({ onAction, match, currentStatus }) {
  const [shotType, setShotType] = useState(null);
  const [team, setTeam] = useState(null);
  const [player, setPlayer] = useState(null);

  const firstSelection = (shotType, team, player) => {
    setShotType(shotType);
    setTeam(team);
    setPlayer(player);
  };

  const secondSelection = (mode) => {
    const { athleteId } = player;
    onAction(shotType, { athleteId, mode });
    // setShotType(null);
    setTeam(null);
    setPlayer(null);
  };

  console.log("InGame", match, currentStatus, shotType, team);
  const isDouble = match.type === "double";

  return (
    <>
      {!shotType && (
        <>
          <div
            className="ion-padding"
            style={{
              display: "flex",
              gap: ".25rem",
              textAlign: "center",
              paddingTop: 0,
              paddingBottom: 0,
            }}
          >
            <div
              className="InGame_FirstTeam"
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
                flex: 1,
              }}
            >
              <b>{match.team_a[0].name}</b>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "10px",
                }}
              >
                <IonButton
                  size="large"
                  expand="full"
                  onClick={() =>
                    firstSelection("winner", "team_a", match.team_a[0])
                  }
                  color={"success"}
                >
                  Vincente
                </IonButton>
                <IonButton
                  size="large"
                  expand="full"
                  color={"warning"}
                  onClick={() =>
                    firstSelection("error", "team_a", match.team_a[0])
                  }
                >
                  Gratuito
                </IonButton>
                <IonButton
                  size="large"
                  expand="full"
                  color={"danger"}
                  onClick={() =>
                    firstSelection("forced", "team_a", match.team_a[0])
                  }
                >
                  Forzato
                </IonButton>
              </div>
            </div>
            <div
              className="InGame_SecondTeam"
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                paddingTop: 0,
              }}
            >
              <b>{match.team_b[0].name}</b>
              <IonButton
                size="large"
                expand="full"
                color={"success"}
                onClick={() =>
                  firstSelection("winner", "team_b", match.team_b[0])
                }
              >
                Vincente
              </IonButton>
              <IonButton
                size="large"
                expand="full"
                color={"warning"}
                onClick={() =>
                  firstSelection("error", "team_b", match.team_b[0])
                }
              >
                Gratuito
              </IonButton>
              <IonButton
                size="large"
                expand="full"
                color={"danger"}
                onClick={() =>
                  firstSelection("forced", "team_b", match.team_b[0])
                }
              >
                Forzato
              </IonButton>
            </div>
          </div>
          {isDouble && (
            <div
              className="ion-padding"
              style={{
                display: "flex",
                gap: ".25rem",
                textAlign: "center",
                paddingTop: 0,
              }}
            >
              <div
                className="InGame_FirstTeam"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "10px",
                  flex: 1,
                }}
              >
                <b>{match.team_a[1].name}</b>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: "10px",
                  }}
                >
                  <IonButton
                    size="large"
                    expand="full"
                    onClick={() =>
                      firstSelection("winner", "team_a", match.team_a[1])
                    }
                    color={"success"}
                  >
                    Vincente
                  </IonButton>
                  <IonButton
                    size="large"
                    expand="full"
                    color={"warning"}
                    onClick={() =>
                      firstSelection("error", "team_a", match.team_a[1])
                    }
                  >
                    Gratuito
                  </IonButton>
                  <IonButton
                    size="large"
                    expand="full"
                    color={"danger"}
                    onClick={() =>
                      firstSelection("forced", "team_a", match.team_a[1])
                    }
                  >
                    Forzato
                  </IonButton>
                </div>
              </div>
              <div
                className="InGame_SecondTeam"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  paddingTop: 0,
                }}
              >
                <b>{match.team_b[1].name}</b>
                <IonButton
                  size="large"
                  expand="full"
                  color={"success"}
                  onClick={() =>
                    firstSelection("winner", "team_b", match.team_b[1])
                  }
                >
                  Vincente
                </IonButton>
                <IonButton
                  size="large"
                  expand="full"
                  color={"warning"}
                  onClick={() =>
                    firstSelection("error", "team_b", match.team_b[1])
                  }
                >
                  Gratuito
                </IonButton>
                <IonButton
                  size="large"
                  expand="full"
                  color={"danger"}
                  onClick={() =>
                    firstSelection("forced", "team_b", match.team_b[1])
                  }
                >
                  Forzato
                </IonButton>
              </div>
            </div>
          )}
        </>
      )}
      {shotType && (
        <div className="ion-padding">
          <div
            // className="ion-padding"
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              gap: ".25rem",
            }}
          >
            <IonButton
              size="large"
              onClick={() => secondSelection("forehand")}
              expand="full"
              style={{ flex: 1 }}
            >
              Dritto
            </IonButton>
            <IonButton
              size="large"
              onClick={() => secondSelection("backhand")}
              expand="full"
              style={{ flex: 1 }}
            >
              Rovescio
            </IonButton>
          </div>
          <div
            // className="ion-padding"
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              gap: ".25rem",
            }}
          >
            <IonButton
              size="large"
              onClick={() => secondSelection("volley")}
              expand="full"
              style={{ flex: 1 }}
            >
              Volee
            </IonButton>
            <IonButton
              size="large"
              onClick={() => secondSelection("smash")}
              expand="full"
              style={{ flex: 1 }}
            >
              Smash
            </IonButton>
          </div>
        </div>
      )}
    </>
  );
}

InGame.propTypes = {
  onAction: PropTypes.func,
  currentStatus: PropTypes.object,
};

export default InGame;
